import React from "react";
import { storyblokEditable } from "gatsby-source-storyblok";
import AdBannerImage from "./adBannerImage";

const AdBannerSection = ({ blok }) => {
  // console.log(blok)
  return(
    <section className="my-16 mx-4">
      <div {...storyblokEditable(blok)} key={blok._uid} className="grid grid-cols-1 md:grid-cols-12 gap-8">
        { blok.columns.map((col) => <AdBannerImage blok={col} key={col._uid} />) }
      </div>
    </section>
  ) 
}

export default AdBannerSection
